export class ListOfTeamResponse {
	id: number;
	name: string;
	sync_state: 0 | 1;
}
